<template>
    <div v-if="$UIPrivilege('dispatching/canceleddepartures', 'update')">
        <p-button @click="onReset" type="default" outline size="sm"><i class="fas fa-sync"></i>{{ $t('button.cancel') }}</p-button>
        <p-button @click="onSubmit" type="success" outline size="sm"><i class="fa fa-check"></i><span>{{ $t('button.save') }}</span></p-button>
        <CanceledDeparturesConfirm
			:modalid="mid"
            :message="msg"
			id="confirmModal"
            ref="confirmModal"
			@ok="this.onConfirmed"
		></CanceledDeparturesConfirm>
    </div>
</template>

<script>
import CanceledDeparturesConfirm from '@/components/Dispatching/TrafficDeviations/CanceledDeparturesConfirm.vue';

export default {
    name: 'CanceledDeparturesButtons',
    components: { CanceledDeparturesConfirm },
    data: function () {
		return {
			modalid: 'confirm-modal',
            message: 'confirm-message'
		};
	},
    computed: {
        mid() {
            return this.modalid;
        },
        msg() {
            return this.message;
        }
    },
    methods: {
        onSubmit() {
            this.modalid = 'confirm-save';
            this.message = this.$t('traffic_deviations.canceled_departures.confirm_save');
            this.$refs.confirmModal.show();
        },
        onReset() {
            this.modalid = 'confirm-reset';
            this.message = this.$t('traffic_deviations.canceled_departures.confirm_reset');
            this.$refs.confirmModal.show();
        },
        onConfirmed() {
            if (this.modalid == 'confirm-save') {
                const cancellationsToAdd = this.$store.state.trafficDeviations.cancellationsToAdd;
                if (cancellationsToAdd) {
                    let cancellations = [];
                    for (const key in cancellationsToAdd) {
                        if (cancellationsToAdd.hasOwnProperty(key)) {
                            cancellations.push(cancellationsToAdd[key]);
                        }
                    }
                    this.$store.dispatch('trafficDeviations/addCanceledDepartures', cancellations);
                }
                const cancellationsToRemove = this.$store.state.trafficDeviations.cancellationsToRemove;
                if (cancellationsToRemove) {
                    let removals = [];
                    for (const key in cancellationsToRemove) {
                        if (cancellationsToRemove.hasOwnProperty(key)) {
                            removals.push(cancellationsToRemove[key]);
                        }
                    }
                    this.$store.dispatch('trafficDeviations/removeCanceledDepartures', removals);
                }
                this.$store.commit('trafficDeviations/updateSelectedDate', '');
            }
            else if (this.modalid =='confirm-reset') {
                this.$store.commit('trafficDeviations/updateSelectedDate', '');
            }
        }
    }
}
</script>